<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
  [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of dataSourceList" [value]="item">
    <!-- <mat-icon mat-list-icon (click)="openEdit(item)">edit</mat-icon> -->
    {{ item.IdPlantillaNomina + ' - ' + item.NplantillaNomina }}
  </mat-list-option>
</mat-selection-list>
